import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Panel, Button, Title } from '@src/components/elements';
const OfferNotificationSubscriptionPanel = ({ setIsModalOpen }) => {
    return (React.createElement(Panel, { className: "m-t-m m-b-m" },
        React.createElement(Title, { level: 3, type: "secondary" },
            React.createElement(FormattedMessage, { id: "offers.offer_notification_subscription_panel.didnt_find_suitable_offer" })),
        React.createElement("div", { className: "text-center" },
            React.createElement(FormattedMessage, { id: "offers.offer_notification_subscription_panel.tell_us_which_offers" })),
        React.createElement("div", { className: "text-center" },
            React.createElement(Button, { className: "m-t-m", onClick: () => {
                    setIsModalOpen(true);
                } },
                React.createElement(FormattedMessage, { id: "offers.offer_notification_subscription_panel.subscribe" })))));
};
export { OfferNotificationSubscriptionPanel };
